import { GlobalStyles } from "./components/styles/global";
import Router from "./router";
import { ThemeProvider } from "styled-components";


interface ThemeProps {
    colors: {
        text: string;
        light_text: string;
        bg: string;
        footer: string;
    };
    mobile: {
        xxs: string;
        sm: string;
        md:string;
        lg:string;
        xl: string;
        xxl: string;
    };
};

const theme:ThemeProps = {
  colors: {
    text: "#000000",
    light_text: "#D8D8D8",
    bg: "##F5F5F5",
    footer: "#000000",
  },
  mobile: {
    xxs: "425px",
    sm: "640px",
    md:"768px",
    lg:"1024px",
    xl: "1280px",
    xxl:"1536px"

  }
};



function App() {
  return (
    <ThemeProvider theme={theme} >
      <GlobalStyles/>
    < Router  />
  </ThemeProvider>
);
}

export default App;
